import type { PatternProps } from "./shared";

export function SolidPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-solidPattern`}
				patternUnits="userSpaceOnUse"
				width="1"
				height="1"
			>
				<rect
					width="1"
					height="1"
					fill={color}
				/>
			</pattern>
		</defs>
	);
}
